import { tokenizer } from '@uhg-abyss/web/tools/tokenizer';

//Util function to reduce the cognitive complexity at components files.
export const getTokenData = (token: string) => tokenizer.parse(token) || {};
